


















































































































import { defineComponent, ref, computed, onMounted, getCurrentInstance } from "vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";

import router from "@/router";
import store from "@/store";
import constants from "./constants";

type Fatura = {
  TituloFatura: string;
  DtVencimento: string;
  Valor: string;
  ValorAtualizado: string;
};

type Beneficiario = {
  Nome: string;
  CPF: string;
  Titulo: string;
};

type DebtData = {
  Nome: string;
  Faturas: Fatura[];
  FormaPagamento: string;
  DiasEmAtraso: number | string;
  Plano: string;
  NumeroContrato: string;
  QuantidadeBeneficiarios: number;
  Beneficiarios: Beneficiario[];
};

async function registerDebtNaturalPersonAction() {
  return await store.dispatch("accessManagement/registerDebtNaturalPerson");
}

export default defineComponent({
  name: "notPay",
  components: {
    FixedButtonRow
  },
  emits: ["show-loading", "hide-loading", "hide-back-button"],
  setup(_) {
    const loading = ref(false);

    const { proxy } = getCurrentInstance();

    const defaultDebtData: DebtData = {
      Nome: "",
      Faturas: [],
      FormaPagamento: "",
      DiasEmAtraso: "",
      Plano: "",
      NumeroContrato: "",
      QuantidadeBeneficiarios: 0,
      Beneficiarios: []
    };

    const debtData = computed<DebtData>(() => {
      try {
        const storeData = store.state.accessManagement?.debtData;
        return { ...defaultDebtData, ...storeData } as DebtData;
      } catch {
        return defaultDebtData;
      }
    });

    const paymentType = computed(() =>
      debtData.value?.FormaPagamento?.toLocaleLowerCase() === "boleto" ? "BOLETO" : "DEBITO"
    );

    const infoTexts = computed(() => {
      return constants[paymentType.value];
    });

    const justifyContent = computed(() => {
      const mobile = globalThis.window !== undefined && globalThis.window.innerWidth <= 600;
      return paymentType && (paymentType.value === "BOLETO" || mobile) ? "space-between" : "center";
    });

    async function next() {
      if (!debtData.value?.Faturas || debtData.value.Faturas.length === 0) return;

      loading.value = true;
      proxy.$emit("show-loading");

      try {
        const result = await registerDebtNaturalPersonAction();

        if (result === "") {
          Swal.fire({
            icon: "error",
            text: "Serviço temporariamente indisponível",
            confirmButtonText: "OK"
          });
        } else {
          router.replace("/");
        }
      } finally {
        loading.value = false;
        proxy.$emit("hide-loading");
      }
    }

    function onSecondaryClick() {
      if (paymentType.value === "BOLETO") {
        router.push("/faturas");
        return;
      }

      globalThis.window.location.href = "tel:08007264000";
    }

    onMounted(() => {
      if (debtData.value.Faturas && store.state.accessManagement.notPay) {
        return;
      }
      router.replace("/");
    });

    setTimeout(() => proxy.$root.$emit("hide-loading"), 500);

    return {
      loading,
      debtData,
      infoTexts,
      paymentType,
      next,
      onSecondaryClick,
      justifyContent
    };
  }
});
